// routes/ProtectedRoute.js
import { Navigate, Outlet } from "react-router-dom";

export default function ProtectedRoute() {
  const token = localStorage.getItem('authToken');
  
  // Check if user is authenticated
  const isAuthenticated = token !== null && token !== '';
  
  // You can also add token validation here if needed
  
  return isAuthenticated ? <Outlet /> : <Navigate to="/" replace />;
}